import type {
  HttpTransport,
  LoginByEmailPayload,
  LoginByEmailResponse,
  RefreshTokenResponse,
} from '@mangovoice/api-client'
import type { components } from '@mangovoice/types/generated/mango-api'

export type { LoginByEmailPayload, LoginByEmailResponse, RefreshTokenResponse }

// TODO: not in OpenAPI spec
export interface PasswordResetConfirmResponse {
  login_url: string
}

export type SecureFaxStatusResponse = components['schemas']['SecureFaxStatus']

export type SecureFaxDownloadResponse =
  components['schemas']['SecureFaxDownloadResponse']

// TODO: not in OpenAPI spec — error shape for secure fax endpoints
export interface SecureFaxErrorResponse {
  type?: string
  code?: string
  detail?: string
  message?: string
  attempts_remaining?: number
}

export function createAuthResource(transport: HttpTransport) {
  return {
    requestPasswordReset: (email: string) =>
      transport.post<void>('/app/v1/password-reset/request/', { email }),

    confirmPasswordReset: (
      uidb64: string,
      token: string,
      newPassword: string,
    ) =>
      transport.post<PasswordResetConfirmResponse>(
        '/app/v1/password-reset/confirm/',
        { uidb64, token, new_password: newPassword },
      ),

    getSecureFaxStatus: (token: string) =>
      transport.get<SecureFaxStatusResponse>(
        `/v1/secure-faxes/${encodeURIComponent(token)}/`,
      ),

    downloadSecureFax: (token: string, password: string) =>
      transport.post<SecureFaxDownloadResponse>(
        `/v1/secure-faxes/${encodeURIComponent(token)}/download/`,
        { password },
      ),

    verifyConnection: async (): Promise<{
      connected: boolean
      reason?: 'unauthorized' | 'network_error'
    }> => {
      const result = await transport.get('/pbxes/?limit=1')
      if (result.ok) return { connected: true }
      if (result.status === 401 || result.status === 403) {
        return { connected: false, reason: 'unauthorized' }
      }
      return { connected: false, reason: 'network_error' }
    },
  }
}
